export default __webpack_public_path__ + "img/confirm-illustration.62000a2724dd213d4c9cb9e88efb7e0e.svg";